import React from 'react'
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import Loader from "react-loader-spinner";
import firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/functions';
import ReactTimeAgo from 'react-time-ago';
import _ from "underscore";

import {showAlertMessage} from "../../../modules/alert";
import {showToastMessage} from "../../../modules/toast";
import {hideLoaderMessage, showLoaderMessage} from "../../../modules/loader";
import UserInfoDialog from '../../user/userInfoDialog';

class TargetScheduleActionSheetComments extends React.Component {
    constructor(props) {
        super(props);
        firebase.firestore().settings({timestampsInSnapshots: true});
        this.scheduleSupplementRef = firebase.firestore().collection('user_schedule_supplement');

        this.state = {
            targetScheduleSupplement: {comments: [], commentText: '', isCommentsLoading: false},
            userInfoDialog: {open: false, uid: ''}
        };
    }

    componentDidMount(){
        this.showTargetScheduleComments(this.props.DOC_ID);
    }

    showTargetScheduleComments = (DOC_ID) => {
        this.setState({targetScheduleSupplement: {...this.state.targetScheduleSupplement, comments: [], isCommentsLoading: true}});
        this.scheduleSupplementRef.doc(DOC_ID).collection('comments').where("use", "==", true).orderBy("date", "desc").get().then((snapshot) => {
            let qd = [];
            snapshot.forEach((doc) => {
                if(doc.exists){
                    let d = doc.data();
                    d['COMMENT_ID'] = doc.id;
                    qd.push(d);
                }
            });
            this.setState({targetScheduleSupplement: {...this.state.targetScheduleSupplement, comments: qd, isCommentsLoading: false}});
        });
    };

    insertScheduleComment = (event) => {
        event.preventDefault();
        const TSS = this.state.targetScheduleSupplement;
        if(TSS.commentText.length < 5){
            this.props.showToastMessage('댓글 5자 이상 입력해주시기 바랍니다.');
            return;
        }
        const DOC_ID = this.props.DOC_ID;
        let commentJson = {uid: this.props.userInfo.uid, nickname: this.props.userInfo.nickname, DOC_ID: DOC_ID, text: TSS.commentText};
        this.props.showLoaderMessage("댓글을 입력중입니다.");

        const insertScheduleComment = firebase.functions().httpsCallable('insertScheduleComment');
        insertScheduleComment(commentJson).then((result) => {
            if(result.data.result === 'success'){
                let comments = this.state.targetScheduleSupplement.comments;
                commentJson.COMMENT_ID = result.data.data.id;
                commentJson.date = result.data.data.date;
                commentJson.dateHistory = result.data.data.dateHistory;
                comments.unshift(commentJson);
                this.props.showToastMessage('댓글을 작성하였습니다.');
                this.setState({targetScheduleSupplement: {...this.state.targetScheduleSupplement, comments: comments, commentText: ''}});
            }else{
                this.props.showToastMessage('댓글 입력 과정에서 문제가 발생하였습니다.');
            }
            this.props.hideLoaderMessage();
        });
    };

    deleteScheduleComment = (event, COMMENT_ID) => {
        event.preventDefault();
        const DOC_ID = this.props.DOC_ID;
        this.props.showLoaderMessage("댓글을 삭제중입니다.");

        if (window.confirm("작성한 댓글을 삭제하시겠습니까?") === true){
            let commentJson = {uid: this.props.userInfo.uid, DOC_ID: DOC_ID, COMMENT_ID: COMMENT_ID};
            const deleteScheduleComment = firebase.functions().httpsCallable('deleteScheduleComment');
            deleteScheduleComment(commentJson).then((result) => {
                if(result.data.result === 'success'){
                    let comments = this.state.targetScheduleSupplement.comments;
                    const commentsIndex = _.findIndex(comments, {COMMENT_ID: COMMENT_ID});
                    comments.splice(commentsIndex, 1);
                    this.setState({targetScheduleSupplement: {...this.state.targetScheduleSupplement, comments: comments}});
                    this.props.showToastMessage('댓글을 삭제하였습니다.');
                }else{
                    this.props.showToastMessage('댓글 삭제 과정에서 문제가 발생하였습니다.');
                }
                this.props.hideLoaderMessage();
            });
        }
    };

    fillInForm = (type, event) => {
        switch (type){
            case 'comment':
                if(event.target.value.length <= 100) {
                    this.setState({targetScheduleSupplement: {...this.state.targetScheduleSupplement, commentText: event.target.value}});
                }else{
                    this.props.showToastMessage('100자 내로 입력해주시기 바립니다.');
                }
                break;
            default:
                console.error('NO TARGET');
        }
    };

    showUserInfoDialog = (event, uid) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({userInfoDialog: {...this.state.userInfoDialog, open: true, uid: uid}});
    };


    render() {
        const TSS = this.state.targetScheduleSupplement;

        return (
            <div className="target-schedule-comments-wrapper">
                <div className="list-header list-header--material">댓글 {TSS.comments.length}건</div>
                <ul className="list list--material">
                    <li className="list-item list-item--material action-sheet-input-wrapper">
                        <form onSubmit={(e) => this.insertScheduleComment(e)}>
                            <input type="text" placeholder="댓글 입력" className="action-sheet-input" value={this.state.targetScheduleSupplement.commentText}
                                   onChange={(e) => this.fillInForm('comment', e)}
                            />
                            <button className="button button--material" onClick={(e) => this.insertScheduleComment(e)}>입력</button>
                        </form>
                    </li>
                </ul>
                <ul className="list list--material comments-list">
                    {
                        TSS.isCommentsLoading === false && TSS.comments.length === 0 ?
                            <li className="list-item list-item--material">
                                <div className="list-item__center list-item--material__center">
                                    <div className="list-item__title list-item--material__title text-center">
                                        댓글이 없습니다.
                                    </div>
                                </div>
                            </li>
                            :
                            null
                    }

                    {
                        TSS.isCommentsLoading  ?
                            <li className="list-item list-item--material">
                                <div className="list-item__title list-item--material__title text-center">
                                    <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                </div>
                            </li>
                            :
                            null
                    }

                    {
                        TSS.comments.map((e, i) => {
                            return (
                                <li key={['expected', 'plan', e, i].join('_')} className="list-item list-item--material">
                                    <div className="list-item__center list-item--material__center">
                                        <div className="list-item__title list-item--material__title">{e.text}</div>
                                        <div className="list-item__subtitle list-item--material__subtitle">
                                            <span onClick={(event) => this.showUserInfoDialog(event, e.uid)}>작성자: {e.nickname}</span> <small><ReactTimeAgo locale="ko">{e.date}</ReactTimeAgo></small>
                                        </div>
                                    </div>

                                    <div className="list-item__right list-item--material__right">
                                        {
                                            this.props.userInfo.uid === e.uid ?
                                                <span className="notification notification--material" onClick={(event) => this.deleteScheduleComment(event, e.COMMENT_ID)}><i className="fa fa-trash-o"/></span>
                                                :
                                                null
                                        }
                                    </div>
                                </li>
                            )
                        })
                    }
                </ul>

                {
                    this.state.userInfoDialog.open ?
                        <UserInfoDialog open={true} uid={this.state.userInfoDialog.uid} hide={() => this.setState({userInfoDialog: {...this.state.userInfoDialog, open: false}})}/>
                        :
                        null
                }
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    showLoaderMessage: message => dispatch(showLoaderMessage(message)),
    hideLoaderMessage: () => dispatch(hideLoaderMessage()),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TargetScheduleActionSheetComments))
